import { useState, useEffect } from "react";
import { Megaphone, X, AlertTriangle, Info } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TYPE_CONFIG = {
  fraud_alert: { icon: AlertTriangle, bg: "bg-red-50 border-red-200", text: "text-red-800", iconColor: "text-red-500" },
  announcement: { icon: Megaphone, bg: "bg-purple-50 border-purple-200", text: "text-purple-800", iconColor: "text-purple-500" },
  news: { icon: Info, bg: "bg-blue-50 border-blue-200", text: "text-blue-800", iconColor: "text-blue-500" },
};

export default function AnnouncementBanner() {
  const [announcements, setAnnouncements] = useState([]);
  const [dismissed, setDismissed] = useState(() => {
    try { return JSON.parse(sessionStorage.getItem("dismissedAnnouncements") || "[]"); } catch { return []; }
  });

  useEffect(() => {
    axios.get(`${API}/announcements/latest`).then(res => {
      setAnnouncements(res.data.announcements || []);
    }).catch(() => {});
  }, []);

  const dismiss = (id) => {
    const updated = [...dismissed, id];
    setDismissed(updated);
    sessionStorage.setItem("dismissedAnnouncements", JSON.stringify(updated));
  };

  const visible = announcements.filter(a => !dismissed.includes(a.id));
  if (visible.length === 0) return null;

  const latest = visible[0];
  const config = TYPE_CONFIG[latest.type] || TYPE_CONFIG.announcement;
  const Icon = config.icon;

  return (
    <div className={`mx-3 mt-2 md:mx-6 rounded-xl border px-3 py-2.5 flex items-start gap-2.5 ${config.bg}`} data-testid="announcement-banner">
      <Icon className={`w-5 h-5 shrink-0 mt-0.5 ${config.iconColor}`} />
      <div className="flex-1 min-w-0">
        <p className={`font-semibold text-sm ${config.text}`}>{latest.title}</p>
        <p className={`text-xs mt-0.5 ${config.text} opacity-80`}>{latest.message}</p>
      </div>
      <button onClick={() => dismiss(latest.id)} className="p-1 rounded-full hover:bg-black/5 shrink-0" data-testid="dismiss-announcement-btn">
        <X className="w-4 h-4 text-gray-400" />
      </button>
    </div>
  );
}
